module.exports = __webpack_public_path__ + "static/media/axcess logo_reversed-1.99edc608.svg";